<ng-container [ngSwitch]="type">
  <ng-template ngSwitchCase="link">
    <a [href]="text" target="_blank"> {{ text }}</a>
  </ng-template>

  <ng-template ngSwitchCase="email">
    <a [href]="'mailto:' + text"> {{ text }}</a>
  </ng-template>

  <ng-template ngSwitchDefault>
    <span>{{ text }}</span>
  </ng-template>
</ng-container>
